import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import classnames from 'classnames';

import Row from '../tag/Row';
import Span from '../tag/Span';
import { isEmpty } from 'lodash';
import HoitopolkuBlock from './HoitopolkuBlock';

import defaultEnabledlogoSrc from '../../images/tays-logo.png';
import defaultDisabledLogoSrc from '../../images/tays-logo-gray.png';

const ServiceCard = ({
  disabled,
  disabledLogoSrc,
  enabledlogoSrc,
  message,
  name,
  isNameHidden,
  blocks,
  children,
  intl,
}) => {
  let logoSrc = disabled ? disabledLogoSrc : enabledlogoSrc;

  if (!disabledLogoSrc && !enabledlogoSrc) {
    logoSrc = disabled ? defaultDisabledLogoSrc : defaultEnabledlogoSrc;
  }

  return (
    <Row>
      <div
        className={classnames('ot-card', 'ot-card__service-card', {
          'ot-card__hpBlock': !isEmpty(blocks),
        })}
      >
        <Row>
          <Span len="4">
            <img
              alt={`${intl.formatMessage({ id: name })} logo`}
              src={logoSrc}
            />
            {!isNameHidden && (
              <div
                className={classnames('text-center', 'ot-card__image-title', {
                  'ot-card__image-title--disabled': disabled,
                })}
              >
                <FormattedMessage id={name} />
              </div>
            )}
          </Span>
          <Span len="8">
            <Row>{message}</Row>
            <Row>{children}</Row>
          </Span>
        </Row>
      </div>
      {blocks && (
        <Row>
          {blocks.map((block) => (
            <HoitopolkuBlock
              key={block.id}
              name={block.text}
              status={block.status}
              enabledlogoSrc={enabledlogoSrc}
              disabledLogoSrc={disabledLogoSrc}
            />
          ))}
        </Row>
      )}
    </Row>
  );
};

export default injectIntl(ServiceCard);
